<template>
  <div class="sla">
    <p class="sla-text">
      Almost there, your account is under review and would be active within
      24hrs after you submit your SLA.
    </p>
    <img
      class="sla-image"
      :src="getImage('stopwatch.png')"
      alt="IMG"
      height="100"
      width="100"
    />
    <div class="sla-action">
      <span
        >Please
        <span class="link-normal" @click="downloadSlaDoc">sign your SLA</span>
        to verify your Account</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "OrganisationVerification",

  methods: {
    downloadSlaDoc() {
      window.open(process.env.VUE_APP_SLA_DOC_URL, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.sla {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
  text-align: center;

  &-text {
    font-size: 1rem;
    width: 40%;
  }

  &-image {
    margin: 20px 0;
  }

  &-action {
    .link-normal {
      cursor: pointer;
      color: var(--ra-red-primary);
      font-weight: 500;
    }
  }
}
</style>
